import { ChangeDetectionStrategy, Component, computed, inject, input, output, Signal } from '@angular/core';

import { MediaQueryService } from '@fcom/common/services';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

import { QuickLink } from './interfaces';

@Component({
  selector: 'fcom-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrl: './quick-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class QuickLinksComponent {
  private mediaQueryService = inject(MediaQueryService);
  private themeService = inject(FinnairThemeService);

  links = input<QuickLink[]>();
  showBorder = input(true);
  showCompact = input(false);
  clickLink = output<QuickLink>();

  isMobile: Signal<boolean>;

  /**
   * @todo During the brand migration, we need to manually adjust which icons to show between
   * brands. When the brand migration is complete, these icons should be updated in the CMS to the
   * non-block variants, and this code below can then be deleted.
   */
  displayLinks = computed((): QuickLink[] | undefined => {
    const links = this.links();
    if (!links || this.themeService.siteTheme() === FinnairTheme.LEGACY) {
      return links;
    }
    return links.map((link) => ({
      ...link,
      iconName: link.iconName?.replace(/-(block|outline)$/, '') as QuickLink['iconName'],
    }));
  });

  constructor() {
    this.isMobile = this.mediaQueryService.isBreakPoint('mobile');
  }
}
